export default __webpack_public_path__ + "static/media/three.f93fa474.jpeg";